import { Route } from 'react-router-dom';
import { lazyPage } from './lazyPage';
// Families sign in with an emailed code, not a Supabase account (#268)
import { ParentRoute } from '../components/parent/ParentSession';

const ParentDashboard = lazyPage(() => import('../pages/parent/ParentDashboard'), 'ParentDashboard');
const DocumentView = lazyPage(() => import('../pages/parent/DocumentView'), 'DocumentView');
const ParentSignIn = lazyPage(() => import('../pages/parent/ParentSignIn'), 'ParentSignIn');
const TeacherDashboard = lazyPage(() => import('../pages/teacher/TeacherDashboard'), 'TeacherDashboard');
const TeacherReviewForm = lazyPage(() => import('../pages/teacher/TeacherReviewForm'), 'TeacherReviewForm');

/** Parent portal. Gated by ParentRoute (emailed-code session), not RequireAccess. */
export const parentRoutes = (
  <>
    <Route path="/parent/sign-in" element={<ParentSignIn />} />
    <Route path="/parent" element={<ParentRoute><ParentDashboard /></ParentRoute>} />
    <Route path="/parent/document/:id" element={<ParentRoute><DocumentView /></ParentRoute>} />
  </>
);

/** Teacher review portal: under the teacher guard. */
export const teacherRoutes = (
  <>
    <Route path="/teacher" element={<TeacherDashboard />} />
    <Route path="/teacher/review/:id" element={<TeacherReviewForm />} />
  </>
);
